var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecordingAnimatedHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.89062,
    cy: 8,
    r: 3,
    fill: "#DE2828"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    from: "#DE2828",
    to: "#FF5C5C",
    dur: "1.5s",
    repeatCount: "indefinite",
    calcMode: "discrete"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3652 8.94482H13.5713L14.8848 11.5229H16.5547L15.0703 8.7251C15.8809 8.40771 16.3496 7.62646 16.3496 6.72314C16.3496 5.33154 15.3975 4.47705 13.8496 4.47705H10.8906V11.5229H12.3652V8.94482ZM12.3652 5.62939H13.6445C14.377 5.62939 14.8359 6.05908 14.8359 6.74268C14.8359 7.44092 14.4014 7.84619 13.6592 7.84619H12.3652V5.62939Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.502 10.3071H19.3086V8.5249H22.3213V7.39209H19.3086V5.69287H22.502V4.47705H17.834V11.5229H22.502V10.3071Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0479 11.7036C28.7471 11.7036 29.9873 10.6733 30.1094 9.16943H28.6738C28.5322 9.9458 27.8975 10.4438 27.0527 10.4438C25.9395 10.4438 25.251 9.50635 25.251 7.99756C25.251 6.48877 25.9395 5.55127 27.0479 5.55127C27.8877 5.55127 28.5273 6.08838 28.6689 6.90381H30.1045C29.9971 5.39014 28.7178 4.29639 27.0479 4.29639C25.002 4.29639 23.7422 5.70752 23.7422 7.99756C23.7422 10.2876 25.0068 11.7036 27.0479 11.7036Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordingAnimatedHovered);
export default __webpack_public_path__ + "static/media/icon-recording-animated-hovered.1f46ef58b9f4ef6735d8946caad3a2f4.svg";
export { ForwardRef as ReactComponent };